import { render, staticRenderFns } from "./reviewdetails.vue?vue&type=template&id=0a6c2e27&scoped=true"
import script from "./reviewdetails.vue?vue&type=script&lang=js"
export * from "./reviewdetails.vue?vue&type=script&lang=js"
import style0 from "./reviewdetails.vue?vue&type=style&index=0&id=0a6c2e27&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c2e27",
  null
  
)

export default component.exports